import { VARIANTS_KEY, VARIANTS_PATH } from 'modules/variant/redux/state'
import getReduxSelector from 'modules/redux/selectors/get'

const getRelatedProducts = state => {
  const path = VARIANTS_PATH[VARIANTS_KEY.RELATED_PRODUCTS]
  return getReduxSelector(path)(state)?.data?.products
}

export default getRelatedProducts
